import type { Action } from 'state/actions';

export function isNavigatingInQuoteBlotter(action: Action): boolean {
  return action.type === 'ROUTE_CHANGED' && action.path === '/quote-blotter';
}

export function isNavigatingOutQuoteBlotter(action: Action): boolean {
  return action.type === 'ROUTE_CHANGED' && action.path !== '/quote-blotter';
}

export function isNavigatingInTradeBlotter(action: Action): boolean {
  return action.type === 'ROUTE_CHANGED' && action.path === '/trade-blotter';
}
export function isNavigatingInSecondaryTradeBlotter(action: Action): boolean {
  return action.type === 'ROUTE_CHANGED' && action.path === '/secondary-trade-blotter';
}

export function isNavigatingInSecondaryOrderBlotter(action: Action): boolean {
  return action.type === 'ROUTE_CHANGED' && action.path === '/secondary-orders-blotter';
}

export function isNavigatingInSecondaryMarketQuotesWorkspace(action: Action): boolean {
  return action.type === 'ROUTE_CHANGED' && action.path === '/secondary-market-quotes-workspace';
}

export function isNavigatingInSecondaryMarketPostEventsWorkspace(action: Action): boolean {
  return action.type === 'ROUTE_CHANGED' && action.path === '/secondary-market-post-event-workspace';
}

export function isNavigatingOutTradeBlotter(action: Action): boolean {
  return action.type === 'ROUTE_CHANGED' && action.path !== '/trade-blotter';
}

export function isNavigatingInBatchWorkspace(action: Action): boolean {
  return action.type === 'ROUTE_CHANGED' && action.path === '/batch';
}

export function isNavigatingInBatchPricer(action: Action): boolean {
  return action.type === 'ROUTE_CHANGED' && action.path === '/batch-workspace';
}
export function isNavigatingInPriceImprovementBlotter(action: Action): boolean {
  return action.type === 'ROUTE_CHANGED' && action.path === '/price-improvement-blotter';
}

export function isNavigatingInScheduledQuotesBlotter(action: Action): boolean {
  return action.type === 'ROUTE_CHANGED' && action.path === '/scheduled-quotes-blotter';
}

export function isNavigatingInAddonManagement(action: Action): boolean {
  return action.type === 'ROUTE_CHANGED' && action.path === '/addon-management';
}
